import { EmpreenderApps } from '../lib/AppsArray';
import SkelletonLoader from './Skelleton';

const LoaderNavigationApps = () => {
	const loadersArray = Array.from({ length: EmpreenderApps.length });
	return (
		<div className=''>
			<div className='custom-scroll h-[calc(50vh+100px)] overflow-hidden'>
				<div className='w-[250px] m-0 flex list-none rounded-md bg-white p-1 flex-col items-center py-2.5'>
					<div className='rounded-md !flex !flex-col items-center justify-between gap-2 w-[95%]'>
						{loadersArray.map((_, index) => (
							<SkelletonLoader key={index} width='100%' className='h-8' />
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
export default LoaderNavigationApps;
